import React, { useState } from 'react'
import { Header, Button, Paragraph, ErrorMark } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import * as UTILS from "../../../app/utils";
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { saveBusinessLicenceApplicationData } from '../../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING } from '../../../app/errors';
import './ConfirmPrincipalBrokerQualification.styles.scss'
import { currentAgentApplicationSelector } from "../../../redux/selector/collectorApplicationSelector";
import { setAgentCacheProperty } from '../../../redux/slice/additionalApplicationsSlice';

export const ConfirmMortgageBrokerQualification = (props) => {

    const { isModal = false, onEditSave = () => {} } = props;

    const currentAgentApp = useSelector(
        currentAgentApplicationSelector
    );


    const companyRjscDetails = currentAgentApp?.businessLicenceData?.companyRjscDetails
    const {legalName, operatingName} = UTILS.decideLegalAndOperatingNames(companyRjscDetails)

    let userType, roleTypeText;
    if(currentAgentApp.licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION) {
        userType = "Associate Mortgage Broker"
        roleTypeText = "an associate mortgage broker"
    }
    else {
        userType = "Mortgage Broker"
        roleTypeText = "a mortgage broker"
    }

    const [applicationSaveError, setApplicationSaveError] = useState(false);
    const [notQualified, setNotQualified] = useState(false);
    const dispatch = useDispatch();
    
    const handleContinue = () => {
        
        setApplicationSaveError(false);

        dispatch(setAgentCacheProperty({
            key: CONST.MORTGAGE_PROPERTY_KEYS.IS_CO_QUALIFICATIONS_ACCEPTED,
            value: true
        }));

        dispatch(saveBusinessLicenceApplicationData(CONST.APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,CONST.APPLICATION_MODE_RENEW))
        .then(data => {
            if(isModal) {
                onEditSave()
            } else {
                dispatch(
                    push(`${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_BROKER_CRIMINAL_RECORD_CHECK}`)
                );
            }
        })
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    const handleCancel = () => {
        setNotQualified(true);
    }

    let orgAuthText = operatingName && legalName ? `${operatingName}(${legalName })` : (operatingName ? operatingName : (legalName ? legalName : ""));

    return (
        <div className={!isModal ? "container" : ""}>
            {!isModal && <TopNavigationBar {...props} />}
            
            <div className="row">
                {!isModal &&
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="mra-renewal-confirm-air-header"
                        header={`${userType} Qualifications`}
                    />
                </div>
                }
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="mra-renewal-confirm-air-text-1"
                        style={{fontWeight: "bold", fontSize: "1.2em"}}
                        text={[
                            `Please review the following requirements`,
                        ]}
                    />
                </div>
            </div>
            
            <div className={"row"}>
                <div className={"col-8"}>
                    <ol className="principalBrokerQualificationReqList">
                        <li>
                            Is the {userType} <b>19 years of age or older</b>?
                        </li>
                        <li>
                            Is the {userType} a <b>resident of Canada</b>?
                        </li>
                        <li>
                            Is the {userType} <b>authorized</b> to carry out the <b>duties and responsibilities</b> of {roleTypeText} on behalf of <b>{orgAuthText}</b>?
                        </li>
                    </ol>
                </div>

                <div className={"col-8 topMarginMedium"}>
                    <b>Does {currentAgentApp.contactName} meet these requirements?</b>
                </div>
            </div>

            <div className="row topMarginMedium">
                <div className="col-lg-8">
                    <div className="col-xs-2">
                        <Button
                            className="btn-lg btn-default"
                            buttonType={"regular_primary"}
                            text={"Yes"}
                            onClick={handleContinue}
                        />
                        {(applicationSaveError)  && ErrorMark()}
                        {applicationSaveError && (
                        <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>
                        )}
                    </div>
                    <div className="col-xs-6">
                        <Button
                            className="btn-lg btn-default"
                            buttonType={"regular_primary"}
                            text={"No"}
                            onClick={handleCancel}
                        />
                        {notQualified  && ErrorMark()}
                        {notQualified && (
                            <div className="ns-error-message" style={{width:300}}>
                                <span className="ns-visually-hidden">Error:</span>
                                {`The ${userType} must qualify for the above requirements to proceed further.`}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
